import { BorderProps, LayoutProps, SpaceProps } from './types';

export const convertToPixel = (value?: number | string) => {
  if (value === undefined) return value;
  return typeof value === 'number' ? `${value}px` : value;
};

export const generateSpaceProps = (props: SpaceProps) => {
  const { m, mt, mr, mb, ml, mx, my, p, pt, pr, pb, pl, px, py } = props;

  const margin = m;
  const marginTop = mt || my;
  const marginRight = mr || mx;
  const marginBottom = mb || my;
  const marginLeft = ml || mx;
  const padding = p;
  const paddingTop = pt || py;
  const paddingRight = pr || px;
  const paddingBottom = pb || py;
  const paddingLeft = pl || px;

  return {
    margin: margin && convertToPixel(margin),
    marginTop: marginTop && convertToPixel(marginTop),
    marginRight: marginRight && convertToPixel(marginRight),
    marginBottom: marginBottom && convertToPixel(marginBottom),
    marginLeft: marginLeft && convertToPixel(marginLeft),
    padding: padding && convertToPixel(padding),
    paddingTop: paddingTop && convertToPixel(paddingTop),
    paddingRight: paddingRight && convertToPixel(paddingRight),
    paddingBottom: paddingBottom && convertToPixel(paddingBottom),
    paddingLeft: paddingLeft && convertToPixel(paddingLeft),
  };
};

export const generateLayoutProps = (props: LayoutProps) => {
  const {
    width,
    w,
    height,
    h,
    minWidth,
    maxWidth,
    minHeight,
    maxHeight,
    position,
    cursor,
  } = props;

  return {
    width: width || w,
    height: height || h,
    minWidth,
    maxWidth,
    minHeight,
    maxHeight,
    position,
    cursor,
  };
};

export const generateBorderProps = (props: BorderProps) => {
  const {
    border,
    borderTop,
    bt,
    borderRight,
    br,
    borderBottom,
    bb,
    borderLeft,
    bl,
    borderColor,
    borderRadius,
    radius,
  } = props;

  return {
    border,
    borderTop: borderTop || bt,
    borderRight: borderRight || br,
    borderBottom: borderBottom || bb,
    borderLeft: borderLeft || bl,
    borderColor,
    borderRadius: borderRadius || radius,
  };
};
